import { render, staticRenderFns } from "./CarouselOld.vue?vue&type=template&id=4c362684&"
import script from "./CarouselOld.vue?vue&type=script&lang=js&"
export * from "./CarouselOld.vue?vue&type=script&lang=js&"
import style0 from "./CarouselOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports